import { AccountTabScreenBoundary } from '@/src/components/navigation/AccountTabScreenBoundary'
import { useAppSession } from '@/src/contexts/AppSessionContext'
import DashboardScreen from '@/src/features/dashboard/screens/DashboardScreen'
import { SubscriptionRequiredPlaceholder } from '@/src/features/paywall/components/SubscriptionRequiredPlaceholder'

export default function DashboardTab() {
  const { hasPurchased } = useAppSession()

  if (!hasPurchased) {
    return <SubscriptionRequiredPlaceholder />
  }

  return (
    <AccountTabScreenBoundary>
      <DashboardScreen />
    </AccountTabScreenBoundary>
  )
}
